<div class="px-4 px-md-5 px-xxl-4">
  <div class="content-section">
    <div>
      <app-crumbs [crumbs]="crumbs"></app-crumbs>
    </div>
    <div class="row content-types">
      <div *ngFor="let recipe of recipe.types; let i = index" class="col-sm-6 col-md-6 col-lg-3 col-xl-2 my-2 my-lg-0" (click)="changeTypeRecipe(i+1, recipe.type)">
        <div class="type d-flex al-center sp-center pointer animated" [ngClass]="currentType == recipe.type ? 'active':'inactive'">
          <img [src]="currentType == recipe.type ? recipe.selected : recipe.unselected" class="me-3 d-none d-sm-block" alt="">
          <span class="fw-semibold">{{recipe.name}}</span>
        </div>
      </div>
    </div>
    <br>
    <app-recipe [products]="products"></app-recipe>
    <br><br>
  </div>
</div>